import { useEffect, useState } from "react";
import { adminApi, errMsg } from "@/lib/api";
import { toast } from "sonner";

// Admin Master → Suporte: saúde do manual da ajuda (o que revisar, o que mais se usa, onde o cliente desiste, o que ficou sem resposta).
export function AjudaManualBox() {
  const [d, setD] = useState(null);
  const [sem, setSem] = useState([]);
  useEffect(() => {
    adminApi.get("/ajuda/manual").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e)));
    adminApi.get("/ajuda/sem-resposta").then((r) => setSem(r.data)).catch(() => {});
  }, []);
  if (!d) return null;
  return (
    <div className="space-y-4 rounded-xl border p-4" data-testid="ajuda-manual-box">
      <div>
        <p className="font-semibold">Manual da ajuda</p>
        <p className="text-sm text-muted-foreground">{d.artigos} artigos · {d.com_guia} com "Mostrar onde clicar" · {d.nunca_vistos} sem nenhum acesso nos últimos 30 dias</p>
      </div>
      <div>
        <p className="text-sm font-medium">Para revisar (mais de {d.prazo_revisao_dias} dias): {d.vencidos.length}</p>
        {d.vencidos.length > 0 && <ul className="mt-1 max-h-32 overflow-y-auto text-xs text-muted-foreground">{d.vencidos.map((a) => <li key={a.id}>{a.titulo} · revisado em {a.revisado}</li>)}</ul>}
      </div>
      <div>
        <p className="text-sm font-medium">Mais usados (30 dias)</p>
        <table className="mt-1 w-full text-xs">
          <thead><tr className="text-left text-muted-foreground"><th>Artigo</th><th>Vistos</th><th>Guias</th><th>Concluídos</th><th>Desistências</th></tr></thead>
          <tbody>{d.uso.slice(0, 15).map((u) => (
            <tr key={u.id} className="border-t"><td className="py-1">{u.titulo}</td><td>{u.artigo_visto}</td><td>{u.guia_inicio}</td><td>{u.guia_fim}</td>
              <td title={Object.entries(u.abandono_passo).map(([p, n]) => `passo ${Number(p) + 1}: ${n}`).join(" · ")}>{u.guia_abandono}</td></tr>))}
          </tbody>
        </table>
        {!d.uso.length && <p className="text-xs text-muted-foreground">Ainda sem uso registrado.</p>}
      </div>
      <div>
        <p className="text-sm font-medium">Perguntas que o manual não respondeu (30 dias)</p>
        <ul className="mt-1 max-h-40 overflow-y-auto text-xs">{sem.map((q, i) => <li key={i} className="border-t py-1">{q.pergunta} <span className="text-muted-foreground">· {q.vezes}x em {q.lojas} loja(s)</span></li>)}</ul>
        {!sem.length && <p className="text-xs text-muted-foreground">Nenhuma.</p>}
      </div>
    </div>
  );
}
